import BaseApiClient from "./base-client";
class TasksApi extends BaseApiClient {
    STUDIES_API_BASE_PATH = "/api/studies";
    getActivityTasks = async (studyId, activityId, includeDeleted = false) => {
        return this.get(`${this.STUDIES_API_BASE_PATH}/${studyId}/activities/${activityId}/tasks`, {
            params: {
                includeDeleted
            }
        });
    };
    getStudyTasks = async (studyId, includeDeleted = false) => {
        return this.get(`${this.STUDIES_API_BASE_PATH}/${studyId}/tasks`, {
            params: {
                includeDeleted
            }
        });
    };
    static instance = new TasksApi();
}
export default TasksApi.instance;
